// SPDX-License-Identifier: AGPL-3.0-or-later

import {Message} from '@app/features/channel/components/Message';
import type {Channel} from '@app/features/channel/models/Channel';
import styles from '@app/features/devtools/components/modals/IARModal.module.css';
import type {IARContext} from '@app/features/devtools/components/modals/IARModal.types';
import {MessagePreviewContext} from '@app/vendor/constants/ChannelConstants';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import type React from 'react';

interface IARModalPreviewProps {
	context: IARContext;
	currentChannel: Channel | null;
}
export const IARModalPreview: React.FC<IARModalPreviewProps> = ({context, currentChannel}) => {
	const {i18n} = useLingui();
	switch (context.type) {
		case 'message':
			if (currentChannel === null) {
				return null;
			}
			return (
				<div className={styles.preview}>
					<Message
						channel={currentChannel}
						message={context.message}
						previewContext={MessagePreviewContext.LIST_POPOUT}
						removeTopSpacing={true}
					/>
				</div>
			);
		case 'user':
			return (
				<div className={styles.identityPreview}>
					<div className={styles.previewTitle}>{context.user.username}</div>
					<div className={styles.previewSubtitle}>
						#{context.user.discriminator?.toString().padStart(4, '0') ?? '0000'}
					</div>
				</div>
			);
		case 'guild':
			return (
				<div className={styles.identityPreview}>
					<div className={styles.previewTitle}>{context.guild.name}</div>
					<div className={styles.previewSubtitle}>{i18n._(msg`Community`)}</div>
				</div>
			);
	}
};
